// import MicroModal from 'micromodal';
import SmoothScroll from "smooth-scroll";
import { domReady } from "./_dom_utils";
// import { MICRO_MODAL_CONFIG } from './_constants';

domReady(() => {
  // MicroModal.init(MICRO_MODAL_CONFIG);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).smoothScroll = new SmoothScroll("[data-smooth-scroll]", {
    speed: 500,
    speedAsDuration: true,
    // offset: 60,
    updateURL: false,
  });
  {
    const targets = document.querySelectorAll('[data-scroll-trigger]');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('js-is-active');
          // 一度きりでよければ監視解除
          observer.unobserve(entry.target);
        } else {
          // entry.target.classList.remove('js-is-active');
        }
      });
    }, {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    });

    targets.forEach((el) => observer.observe(el));
  }

  const menuElement = document.querySelector<HTMLElement>(".c-menu");
  if (!menuElement) {
    throw new Error("menuElement is null");
  }

  const menuOpenElement = document.querySelector<HTMLElement>(".c-menu__open");
  if (!menuOpenElement) {
    throw new Error("menuOpenElement is null");
  }
  const menuCloseElement = document.querySelector<HTMLElement>(".c-menu__close");
  if (!menuCloseElement) {
    throw new Error("menuCloseElement is null");
  }
  const navItemElementList = document.querySelectorAll<HTMLElement>(".c-nav__item");


  menuOpenElement.addEventListener("click", () => {
    menuElement.classList.add("js-is-active");
  });
  menuCloseElement.addEventListener("click", () => {
    menuElement.classList.remove("js-is-active");
  })

  navItemElementList.forEach((navItemElement) => {
    navItemElement.addEventListener("click", () => {
      menuElement.classList.remove("js-is-active");
    })
  })


});
